import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Button,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { dropContent } from '../NavButtons';

interface CollapsedOptions {
  dropOptions?: dropContent[];
}

export const CollapsedOptions: React.FC<CollapsedOptions> = ({
  dropOptions,
}) => {
  return (
    <MenuList
      pb="0px"
      ml="70px"
      mt="-70px"
      bg="button"
      borderColor="ocean.400"
      flexDir="column"
    >
      <>
        {dropOptions?.map(drop => {
          return (
            <Accordion borderColor="transparent" allowToggle key={drop.name}>
              <AccordionItem>
                {!drop.insideDrops ? (
                  <NavLink to={drop.path}>
                    <MenuItem
                      bg="button"
                      as={Button}
                      key={drop.name}
                      isDisabled={false}
                      _hover={{ bg: 'button' }}
                      _active={{ bg: 'button' }}
                    >
                      {drop.name}
                    </MenuItem>
                  </NavLink>
                ) : (
                  <AccordionButton
                    bg="button"
                    as={Button}
                    key={drop.name}
                    rightIcon={<AccordionIcon />}
                    _hover={{ bg: 'button' }}
                    _active={{ bg: 'button' }}
                  >
                    {drop.name}
                  </AccordionButton>
                )}

                <AccordionPanel p="0px" m="0">
                  {drop.insideDrops?.map(inside => {
                    return (
                      <NavLink to={inside.path} key={inside.name}>
                        <MenuItem bg="ocean.100" as={Button}>
                          {inside.name}
                        </MenuItem>
                      </NavLink>
                    );
                  })}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          );
        })}
      </>
    </MenuList>
  );
};
